import Axios from 'axios';
import { Config } from '../apiRoutes';
import { authHeaders, apiErrorMessage } from '../headers';

import {
  TOTES_INDEX_REQUESTED,
  TOTES_INDEX_SUCCESS,
  TOTES_INDEX_FAILURE,
  TOTES_UNDO_REQUESTED,
  TOTES_UNDO_SUCCESS,
  TOTES_UNDO_FAILURE,
  TOTES_DELETE_REQUESTED,
  TOTES_DELETE_SUCCESS,
  TOTES_DELETE_FAILURE,
  TOTES_ASSIGN_REQUESTED,
  TOTES_ASSIGN_SUCCESS,
  TOTES_ASSIGN_FAILURE,
} from '../types';

const TOTES_LIMIT = 100;

export const totesIndexRequested = (append = false) => {
  return {
    type: TOTES_INDEX_REQUESTED,
    append: append
  }
};

export const totesIndexSuccess = (totes, append = false) => {
  return {
    type: TOTES_INDEX_SUCCESS,
    payload: totes,
    append: append
  }
};

export const totesIndexFailure = (error) => {
  return {
    type: TOTES_INDEX_FAILURE,
    error: error
  }
};

export const totesIndex = (continuationToken = null, append = false) => {
  return async (dispatch) => {
    dispatch(totesIndexRequested(append));

    const endPoint = Config.baseUrl + Config.totes;
    const params = {
      limit: TOTES_LIMIT,
      status: 'unassigned'
    };

    if (continuationToken) {
      params.continuation_token = continuationToken;
    }

    return Axios.get(endPoint, { headers: await authHeaders(), params: params })
      .then((response) => {
        dispatch(totesIndexSuccess(response.data, append));

        if (response.data.continuation_token) {
          return dispatch(totesIndex(response.data.continuation_token, true));
        }

        return response.data;
      })
      .catch((error) => {
        dispatch(totesIndexFailure(apiErrorMessage(error, 'Could not load totes.')));
      });
  }
};

// Assigns the selected totes to new batches. The cart layout's rows and
// columns determine how many totes each batch holds.
export const assignTotesToBatches = (cartLayoutId, toteIds) => {
  return async (dispatch) => {
    dispatch(totesActionRequested(TOTES_ASSIGN_REQUESTED));

    const endPoint = Config.baseUrl + Config.batches;

    try {
      const response = await Axios.post(endPoint, {
        cart_layout_id: cartLayoutId,
        tote_ids: toteIds
      }, {
        headers: await authHeaders()
      });

      dispatch(totesActionSuccess(TOTES_ASSIGN_SUCCESS, response.data));
      return response.data;
    } catch(error) {
      dispatch(totesActionFailure(TOTES_ASSIGN_FAILURE, apiErrorMessage(error, 'Could not assign totes to batches.')));
      return null;
    }
  }
};

const totesActionRequested = (type) => ({ type: type });
const totesActionSuccess = (type, result) => ({ type: type, payload: result });
const totesActionFailure = (type, error) => ({ type: type, error: error });

const postTotesAction = (route, orderShipmentIds, types, fallback) => {
  return async (dispatch) => {
    dispatch(totesActionRequested(types.requested));

    const endPoint = Config.baseUrl + route;

    try {
      const response = await Axios.post(endPoint, { order_shipment_ids: orderShipmentIds }, {
        headers: await authHeaders()
      });

      dispatch(totesActionSuccess(types.success, response.data));
      return response.data;
    } catch(error) {
      dispatch(totesActionFailure(types.failure, apiErrorMessage(error, fallback)));
      return null;
    }
  }
};

// Deletes all totes for the given order shipments and marks those shipments
// as unconverted, so they appear as prepared order shipments again.
export const totesUndo = (orderShipmentIds) => {
  return postTotesAction(Config.totesUndo, orderShipmentIds, {
    requested: TOTES_UNDO_REQUESTED,
    success: TOTES_UNDO_SUCCESS,
    failure: TOTES_UNDO_FAILURE
  }, 'Could not undo tote creation.');
};

// Permanently deletes all totes for the given order shipments, leaving them
// marked as converted so they are never processed through the app.
export const totesDelete = (orderShipmentIds) => {
  return postTotesAction(Config.totesDelete, orderShipmentIds, {
    requested: TOTES_DELETE_REQUESTED,
    success: TOTES_DELETE_SUCCESS,
    failure: TOTES_DELETE_FAILURE
  }, 'Could not delete totes.');
};
